export default function FilterUnchecked() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0.5 0.5 14 14">
      <g id="Checkbox">
        <path id="Vector" d="M11.5 1H3.5C2.11929 1 1 2.11929 1 3.5V11.5C1 12.8807 2.11929 14 3.5 14H11.5C12.8807 14 14 12.8807 14 11.5V3.5C14 2.11929 12.8807 1 11.5 1Z" fill="white" stroke="#CFCFCF" />
      </g>
    </svg>
  );
}
